---
title: Plan, dodatki i faktury
parent: Dokumentacja
parentHref: /docs
---

<script>
  import DomainTlds from "@/components/domain-tlds.svelte"
</script>

# Plan, dodatki, faktury i strony prawne

## Jeden plan ze wszystkim w zestawie

TOBY oferuje jeden kompletny plan bez opłaty aktywacyjnej i bez ukrytych poziomów:

- **Rozliczenie miesięczne lub roczne:** Wybierz elastyczne rozliczenie miesięczne (możliwość rezygnacji w każdej chwili) lub tańsze rozliczenie roczne (również płatne na fakturę). Aktualne ceny znajdziesz w [cenniku](/pl/pricing).

Każda subskrypcja obejmuje:

- **Własną domenę** (<DomainTlds />) — w tym przeniesienie istniejącej domeny (Domain-Umzug)
- **1 adres e-mail** (info@...) ze **skrzynką pocztową 15 GB (Maxi-Postfach)** i nieograniczoną liczbą adresów przekierowujących
- **Do 15 stron** — tworzonych i aktualizowanych przez czat, głos lub przesłanie zdjęcia
- **1 dodatkowy język** (łącznie 2 języki) z automatycznym tłumaczeniem przy publikacji
- **Newsletter** z **1000 e-maili / miesiąc**
- **Analityka odwiedzin** (przyjazna prywatności, bez banerów cookie)
- **Pakiet startowy pocztą** (naklejka na drzwi i stojak QR A5 na stół)
- **Hosting w UE** z automatycznym zabezpieczeniem SSL

## Opcjonalne dodatki

Jeśli Państwa firma rozwija się powyżej zawartych limitów, mogą Państwo w każdej chwili dodać elastyczne moduły w **Ustawienia → Subskrypcja** (możliwość rezygnacji miesięcznie, zobacz [cennik](/pl/pricing)):

- **+15 GB pamięci e-mail** (lub dodatkowa skrzynka pocztowa)
- **+1 dodatkowy język strony internetowej**
- **+15 dodatkowych stron**
- **+5000 e-maili newsletter / miesiąc**

## Uzyskanie prawidłowej faktury biznesowej (Strona internetowa vs. Google Play)

Jeśli prowadzą Państwo firmę, praktykę lub działalność freelancerską i potrzebują Państwo **prawidłowej faktury biznesowej podlegającej odliczeniu podatku (ordentliche Rechnung)** z nazwą firmy, adresem biznesowym i oddzielnie wykazanym VAT (MwSt.), proszę zwrócić uwagę na miejsce subskrypcji:

- **Subskrypcja na stronie internetowej (tobysite.com przez Stripe):** Zawsze otrzymują Państwo **prawidłową fakturę biznesową z VAT** od nas, wystawioną na Państwa firmę. Mogą Państwo pobrać wszystkie poprzednie faktury i w każdej chwili zaktualizować adres rozliczeniowy firmy w **Ustawienia → Subskrypcja**.
- **Subskrypcja w aplikacji Android (zakup w aplikacji Google Play):** Gdy subskrybują Państwo przez Google Play, Google przetwarza płatność jako sprzedawca dokumentujący transakcję i wystawia jedynie standardowe potwierdzenie płatności Google Play. **Nie możemy wystawić biznesowej faktury VAT (ordentliche Rechnung) dla subskrypcji rozliczanych przez Google Play.**

> **Wskazówka:** Mogą Państwo subskrybować na **tobysite.com** w przeglądarce, aby otrzymywać prawidłowe faktury biznesowe Stripe i nadal korzystać z aplikacji TOBY na Androida i iOS z Państwa kontem bez dodatkowych kosztów.

## Dodawanie stopki redakcyjnej (Impressum) i polityki prywatności (Datenschutz)

- **Własny tekst prawny:** Ponieważ wymogi prawne zależą od struktury działalności, zawodu i kraju, **TOBY nie generuje porad prawnych ani nie pisze tekstów prawnych (Impressum lub Datenschutzerklärung) samodzielnie.**
- **Jak je dodać:** Wystarczy wkleić istniejący tekst stopki redakcyjnej lub polityki prywatności do czatu (lub przesłać go jako dokument Word/PDF, albo poprosić TOBY o skopiowanie go ze starej strony internetowej) i powiedzieć *„Umieść to na naszej stronie Impressum."* TOBY utworzy strony i połączy je w stopce strony internetowej.
